import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/blagajna")({
  head: () => ({
    meta: [
      { title: "Blagajna — kupish.si" },
      { name: "description", content: "Zaključite nakup izdelkov različnih ponudnikov varno in preprosto na kupish.si." },
      { name: "robots", content: "noindex, follow" },
      { property: "og:title", content: "Blagajna — kupish.si" },
      { property: "og:description", content: "Varen zaključek nakupa izdelkov različnih ponudnikov na kupish.si." },
      { property: "og:url", content: "https://kupish.si/blagajna" },
    ],
      links: [{ rel: "canonical", href: "https://kupish.si/blagajna" }],
  }),
  component: Page,
});

function Page() {
  return (
    <section className="mx-auto max-w-2xl px-6 py-24 text-center">
      <div className="eyebrow">Blagajna</div>
      <h1 className="font-serif text-5xl mt-3">Zaključek nakupa</h1>
      <p className="mt-6 text-muted-foreground">
        Vašo košarico zaključite na strani košarice.
      </p>
      <Link to="/kosarica" className="mt-8 inline-block px-6 py-3 bg-accent text-accent-foreground rounded">
        Pojdi v košarico
      </Link>
    </section>
  );
}
